/**
 * CleanDisplayName return display name in an seo friendly format
 * @param {String} displayName
 * @return clean display name
 */
const cleanDisplayName = (displayName) => {
  if (!displayName) return 'Fanatical User';

  if (typeof displayName === 'string' && !displayName.replace(/\s/g, '').length) return 'Fanatical User';

  return displayName;
};

export default cleanDisplayName;
